import { FilterPlaceType, PlaceFilters } from "@ac-expo/api-types";

const userPlacesQueryKeys = {
  all: ["userPlaces"] as const,
  lists: (filters: FilterPlaceType | PlaceFilters | undefined) =>
    [...userPlacesQueryKeys.all, filters] as const,
  me: () => [...userPlacesQueryKeys.all, "me"] as const,
  place: (id: string) => [...userPlacesQueryKeys.all, id] as const,
  autoComplete: (input: string) => [...userPlacesQueryKeys.all, input] as const,
};

export default userPlacesQueryKeys;
